// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"_3ea6fa5da8--tooltip--M1G81","arrow_tooltip":"_3ea6fa5da8--arrow_tooltip--xm3aH","arrow":"_3ea6fa5da8--arrow--QDoVo"};